import React, { AnchorHTMLAttributes, ButtonHTMLAttributes, DetailedHTMLProps } from 'react';
import { Link } from 'react-router-dom';
import styles from './Button.module.scss';

export type ButtonProps = {
    variant?: 'primary' | 'secondary' | 'third' | 'forth' | 'danger' | 'empty' | 'none';
    size?: 'normal' | 'medium' | 'small';
    fw?: boolean;
    href?: string;
} & Omit<DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, 'href'>;

const Button = ({ variant, size, fw, href, ...props }: ButtonProps, ref: React.LegacyRef<HTMLButtonElement & HTMLAnchorElement>) => {
    const className = `${styles.button} ${styles[variant ?? 'primary']} ${styles[size ?? 'normal']} ${fw ? styles.fw : ''} ${props.className ?? ''}`;

    if (href) {
        const { type, disabled, onClick, ...anchorSafeProps } = props as any;
        if (disabled) {
            return (
                <button
                    type="button"
                    {...props}
                    ref={ref}
                    className={className}
                />
            );
        }
        return (
            <Link
                to={href}
                onClick={onClick as unknown as AnchorHTMLAttributes<HTMLAnchorElement>['onClick']}
                {...anchorSafeProps}
                ref={ref}
                className={className}
                style={{ textDecoration: 'none', ...(props.style ?? {}) }}
            />
        );
    }

    return (
        <button
            type="button"
            {...props}
            ref={ref}
            className={className}
        />
    );
};

export default React.forwardRef(Button);
